import React, { Component } from 'react';
import { Cell, Grid } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { SegmentedControl } from 'segmented-control';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import PerfChart from '../component/PerfChart';
import PerfData from '../component/PerfData';
import SecureShow from '../component/SecureShow';
import { AppProperties } from '../common/function';
//import ViewScoreArchives from '../component/ViewScoreArchive'
import '../css/archive.css';
import '../css/Dashboard.css';







export default class PerfGraphs extends Component{

    appProperties = AppProperties();

    constructor(props){
        super(props);
        this.state = {
            archiveInProgress:false,
            showPerfChart:true,
            showPerfData:false,
            semesters : [],
            loading:true
        };
        console.debug("archive ",this.state.archiveMode)
    }

    
    componentWillMount(){

        this.getAllSemesters().then( semesters => {
            if(semesters){
                this.setState({semesters,loading:false});
            }
        })
    }

    getAllSemesters = async () => {
        let getAllSemestersResp = await  ApiRequestService({
                method: 'post',
                url: '/getAllSemesters'
            });

        try{
            if(getAllSemestersResp && getAllSemestersResp.data && getAllSemestersResp.data.data){
                return  getAllSemestersResp.data.data;
            }else if(getAllSemestersResp.data && getAllSemestersResp.data.status && getAllSemestersResp.data.message ){
                NotificationManager.error("Get All Semesters Failed with Error - "+getAllSemestersResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Get All Semesters Failed with Unknown Error","Error",5000);
            }
        }catch(err){
            NotificationManager.error("Get All Semesters Failed with Error "+err,"Error",5000);
        }

        return null;
    }
    

    //Event Handlers
    tabOnChange =(clickedValue) =>{
        console.debug("tabOnChange : "+clickedValue);
        if(clickedValue === 'perfChart'){
            this.setState({showPerfChart:true,showPerfData:false});
        }
        if(clickedValue === 'perfData'){
            this.setState({showPerfChart:false,showPerfData:true});
        }

        
    }

    render(){
        if(this.state.loading){
            return  <LoadingSpinner/>
        }
        return  <SecureShow targetRole={1} >
                    <Grid gutter={1} className="gradeBookPageContainer">
                        {(this.props.archiveMode === undefined || this.props.archiveMode === null) || !this.props.archiveMode ?
                        <Cell size={12} >
                            {this.appProperties.schoolMode?
                                <h1 className = "md-text--theme-primary" style = {{textAlign:'center', fontSize: 40}}>
                                Performance Analytics for Current Academic Year</h1>
                            :
                                <h1 className = "md-text--theme-primary" style = {{textAlign:'center', fontSize: 40}}>
                                Performance Analytics for Current Semester</h1>
                            }
                            
                        </Cell>  
                        :null                      
                        }
                        <Cell size={6}>
                            <h4 className = "md-text--theme-primary" style = {{marginBottom: "0px"}}>
                                *New data will be available the next day
                            </h4>
                            <SegmentedControl
                                name="perf-tabs"
                                style={{color: '#bb0000'}}
                                options={[
                                { label: 'Performance Chart', value: 'perfChart', default: true },
                                { label: 'Performance Data', value: 'perfData' }
                                ]}
                                setValue={newValue => this.tabOnChange(newValue)}
                            />
                        </Cell>
                        
                        {
                             this.state.showPerfChart?
                             <Cell size={12} className="gradebook-cell">   
                                <PerfChart archiveMode={this.props.archiveMode} semesters={this.state.semesters}/>
                            </Cell>
                            :
                            undefined
                        }
                        {
                            this.state.showPerfData?
                            <Cell size={12} className="gradebook-cell">   
                               <PerfData  archiveMode={this.props.archiveMode} semesters={this.state.semesters}/>
                              
                           </Cell>
                           :
                           undefined
                            
                        }
     
                        
                    </Grid>
                </SecureShow>
    }
}
